const RECEIVE_ADPLATFORM_SETTINGS = 'src/adPlatformSettings/RECEIVE_ADPLATFORM_SETTINGS' as const;
const CLEAR_ADPLATFORM_SETTINGS = 'src/adPlatformSettings/CLEAR_ADPLATFORM_SETTINGS' as const;

export default {
  CLEAR_ADPLATFORM_SETTINGS,
  RECEIVE_ADPLATFORM_SETTINGS
};
